import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { LoginWithPassword } from '../components/LoginWithPassword';
import { AdminSetlistController } from '../components/AdminSetlistController';

export const Admin = () => {
  const { user } = useAuth();

  // Show login form if not authenticated
  if (!user) {
    return (
      <div className="admin-page">
        <div style={{ maxWidth: '400px', margin: '0 auto', paddingTop: '2rem' }}>
          <h2 style={{ color: '#feda2d', textAlign: 'center', marginBottom: '2rem' }}>
            Admin Login
          </h2>
          <LoginWithPassword onSwitch={() => {}} hideSignUp={true} redirectTo={null} />
          <p style={{ textAlign: 'center', marginTop: '1rem', color: '#999', fontSize: '0.9rem' }}>
            Admin access only
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="admin-page">
      <AdminSetlistController />
    </div>
  );
};

export default Admin;
